import { FC } from 'react';
import './ProjectBreadcrumbs.scss';
import { useGetProject } from '../../../hooks/api/projects';

interface ProjectBreadcrumbsProps {
  match?: any;
}

const ProjectBreadcrumbs: FC<ProjectBreadcrumbsProps> = ({ match }) => {
  const { projectId } = match?.params ?? '';

  const { data: projectData } = useGetProject(projectId);

  return <>{projectData?.data.name}</>;
};

export default ProjectBreadcrumbs;
